import { render, staticRenderFns } from "./DepartWindow.vue?vue&type=template&id=0898a936&scoped=true&"
import script from "./DepartWindow.vue?vue&type=script&lang=js&"
export * from "./DepartWindow.vue?vue&type=script&lang=js&"
import style0 from "./DepartWindow.vue?vue&type=style&index=0&id=0898a936&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0898a936",
  null
  
)

export default component.exports